export interface DryingProgramChangeAccessParams {
  dryRunActive: boolean;
  isMini: boolean;
  hasOverrideAccess: boolean;
}

/**
 * Returns whether the drying program picker should be enabled.
 *
 * Program changes are always allowed before a dry run starts.
 * During an active dry run, mini devices are allowed to change program
 * without additional permission; all other devices require override access.
 */
export function canChangeDryingProgram(
  params: DryingProgramChangeAccessParams
) {
  const { dryRunActive, isMini, hasOverrideAccess } = params;

  if (!dryRunActive) {
    return true;
  }

  return isMini || hasOverrideAccess;
}